<template>
  <div class="pageCentent">
    <!-- 搜索表单 -->
    <a-form-model size="small" layout="inline" @keyup.native.enter="search()">
      <a-form-model-item label="群名称">
        <a-input
          placeholder="请输入群名称"
          v-model="ajaxparams['group_name_like']"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button icon="search" @click="$refs.myTable.search()" type="primary">
          搜索
        </a-button>
      </a-form-model-item>
    </a-form-model>

    <!-- 添加按钮 -->
    <a-button class="mt10" type="primary" @click="showAddDialog()">
      添加微信群
    </a-button>

    <!-- 微信群列表 -->
    <MyTable
      class="mt10"
      :isSelection="false"
      :apiUrl="apiUrl"
      :params="ajaxparams"
      ref="myTable"
      :columns="columns"
    >
      <a-space slot="group_name" slot-scope="item, row">
        <span :title="row.group_name">{{ row.group_name }}</span>
      </a-space>

      <a-space slot="member_name" slot-scope="item, row">
        <span v-if="row.member_name" :title="row.member_name">
          {{ row.member_name }}
        </span>
        <span v-else>-</span>
      </a-space>

      <a-space slot="action" slot-scope="item, row">
        <a-button size="small" type="primary" @click="showEditDialog(row)">
          编辑
        </a-button>
      </a-space>
    </MyTable>

    <!-- 添加/编辑微信群模态框 -->
    <a-modal
      :title="isEdit ? '编辑微信群' : '添加微信群'"
      :visible="dialogVisible"
      @ok="submitGroup"
      @cancel="cancelDialog"
      width="600px"
      :confirmLoading="submitLoading"
    >
      <a-form-model
        :model="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item label="群名称" required>
          <a-input v-model="form.group_name" placeholder="请输入群名称" />
        </a-form-model-item>

        <a-form-model-item label="成员名称">
          <a-input v-model="form.member_name" placeholder="请输入成员名称" />
        </a-form-model-item>

        <a-form-model-item label="用户ID" required>
          <a-input
            v-model="form.user_id"
            placeholder="请输入用户ID"
            type="number"
          />
        </a-form-model-item>

        <a-form-model-item label="用户名" required>
          <a-input v-model="form.user_name" placeholder="请输入用户名" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import MyTable from "@/components/myTable.vue";
import { wechatGroups_index, wechatGroups_save } from "@/api/manager";

export default {
  components: { MyTable },
  data() {
    return {
      apiUrl: wechatGroups_index,
      ajaxparams: {
        limit: 10,
        page: 1,
      },
      dialogVisible: false,
      submitLoading: false,
      isEdit: false,
      form: {
        id: null,
        group_name: "",
        member_name: "",
        user_id: "",
        user_name: "",
      },
      columns: [
        {
          title: "操作",
          key: "action",
          width: 120,
          scopedSlots: { customRender: "action" },
        },
        { title: "ID", dataIndex: "id", key: "id", width: 80 },
        {
          title: "群名称",
          dataIndex: "group_name",
          key: "group_name",
          width: 250,
          scopedSlots: { customRender: "group_name" },
        },
        {
          title: "成员名称",
          dataIndex: "member_name",
          key: "member_name",
          width: 150,
          scopedSlots: { customRender: "member_name" },
        },
        {
          title: "用户名",
          dataIndex: "user_name",
          key: "user_name",
          width: 120,
        },
        { title: "用户ID", dataIndex: "user_id", key: "user_id", width: 100 },
        {
          title: "创建时间",
          dataIndex: "create_at",
          key: "create_at",
          width: 180,
        },
        {
          title: "更新时间",
          dataIndex: "update_at",
          key: "update_at",
          width: 180,
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 搜索
    search() {
      this.$refs.myTable.search();
    },

    // 显示添加对话框
    showAddDialog() {
      this.isEdit = false;
      this.dialogVisible = true;
      this.resetForm();
    },

    // 显示编辑对话框
    showEditDialog(row) {
      this.isEdit = true;
      this.dialogVisible = true;
      this.form = {
        id: row.id,
        group_name: row.group_name,
        member_name: row.member_name || "",
        user_id: row.user_id,
        user_name: row.user_name,
      };
    },

    // 取消对话框
    cancelDialog() {
      this.dialogVisible = false;
      this.resetForm();
    },

    // 重置表单
    resetForm() {
      this.form = {
        id: null,
        group_name: "",
        member_name: "",
        user_id: "",
        user_name: "",
      };
    },

    // 提交微信群信息
    submitGroup() {
      // 表单验证
      if (!this.form.group_name) {
        this.$message.error("请输入群名称");
        return;
      }
      if (!this.form.user_id) {
        this.$message.error("请输入用户ID");
        return;
      }
      if (!this.form.user_name) {
        this.$message.error("请输入用户名");
        return;
      }

      this.submitLoading = true;

      const postData = {
        group_name: this.form.group_name,
        member_name: this.form.member_name,
        user_id: this.form.user_id,
        user_name: this.form.user_name,
      };

      // 如果是编辑模式，添加id
      if (this.isEdit && this.form.id) {
        postData.id = this.form.id;
      }

      wechatGroups_save(postData)
        .then((res) => {
          this.submitLoading = false;
          if (res) {
            this.$message.success(
              this.isEdit ? "编辑微信群成功" : "添加微信群成功"
            );
            this.dialogVisible = false;
            this.resetForm();
            this.$refs.myTable.getList();
          }
        })
        .catch((error) => {
          this.submitLoading = false;
          this.$message.error("操作失败，请重试");
        });
    },
  },
};
</script>

<style scoped>
.mt10 {
  margin-top: 10px;
}

.ml10 {
  margin-left: 10px;
}

.ellipsis-1 {
  max-width: 180px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-wrap: break-word;
  word-break: break-all;
}
</style>